import BaseServices from "../based/services/BaseServices";

const GameServices = {
    CreateUpdateGame: async (game) => {
        return BaseServices.Post(`/api/game/create-update-game`, game);
    },
    GetGameById: async (gameId) => {
        return BaseServices.Get(`/api/game/get-game-by-id/${gameId}`);
    },
    GetGames: async (paging) => {
        return BaseServices.Post(`/api/game/get-games`, paging);
    },
    CreateUpdateGameRound: async (gameRound) => {
        return BaseServices.Post(`/api/game/create-update-game-round`, gameRound);
    },
    GetGameRoundByGameId: async (gameId) => {
        return BaseServices.Get(`/api/game/get-game-round-by-id/${gameId}`);
    },
    RemoveGameRoundById: async (gameRoundId) => {
        return BaseServices.Delete(`/api/game/remove-game-round-by-id/${gameRoundId}`);
    },
    TakeNote: async (model) => {
        return BaseServices.Post(`/api/game/take-note`, model);
    },
    BurnCard: async (model) => {
        return BaseServices.Post(`/api/game/burn-card`, model);
    },
    DeleteGame: async (gameId) => {
        return BaseServices.Get(`/api/game/delete-game/${gameId}`);
    },
    SimulatorGame: async (cuttingNumber) => {
        return BaseServices.Get(`/api/game/simulator-game/` + cuttingNumber);
    },
    GetGameRoundAccumulateModels: async (gameId) => {
        return BaseServices.Get(`/api/game/get-game-round-accumulate-models/${gameId}`);
    },
    HandleThreshold: async (model) => {
        return BaseServices.Post(`/api/game/handle-threshold`, model);
    },
    HandleSPSByGame: async (model) => {
        return BaseServices.Post(`/api/game/handle-scan-sps`, model);
    },
    GetGameClientByPage: async (paging) => {
        return BaseServices.Post(`/api/game/get-game-client-by-page`, paging);
    },
    GetDeltaListByGameId: async (nhlGameId) => {
        return BaseServices.Get(`/api/game/get-delta-list/${nhlGameId}`);
    },
    DirectGetDeltaListByGameId: async (nhlGameId) => {
        return BaseServices.Get(`/api/game/direct-get-delta-list/${nhlGameId}`);
    },
    UpdatePeriodScore: async (nhlGameId) => {
        return BaseServices.Get(`/api/game/update-period-score/${nhlGameId}`);
    },
    UpdateEventInfo: async (nhlGameId) => {
        return BaseServices.Get(`/api/game/update-event-info/${nhlGameId}`);
    },
    HandleIndexByGameId: async (nhlGameId) => {
        return BaseServices.Get(`/api/game/handle-index/${nhlGameId}`);
    },
};

export default GameServices;
